'use strict';
/**
 * MaskPattern
 * @author Kazuhiko Arase
 */
export enum MaskPattern {

  /**
   * mask pattern 000
   */
  PATTERN000 = 0b000,

  /**
   * mask pattern 001
   */
  PATTERN001 = 0b001,

  /**
   * mask pattern 010
   */
  PATTERN010 = 0b010,

  /**
   * mask pattern 011
   */
  PATTERN011 = 0b011,

  /**
   * mask pattern 100
   */
  PATTERN100 = 0b100,

  /**
   * mask pattern 101
   */
  PATTERN101 = 0b101,

  /**
   * mask pattern 110
   */
  PATTERN110 = 0b110,

  /**
   * mask pattern 111
   */
  PATTERN111 = 0b111
}



// WEBPACK FOOTER //
// ./ts/qrcode/MaskPattern.ts